export default __webpack_public_path__ + "static/media/marie-france.379d3d56.jpg";